import { ButtonTriggerEvent } from '../../../common/components';

export class PullGooglePlaceTypeModalActions {
    confirm: (data: any) => void;
    cancel?: () => void;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/pull.google.place.type.modal/pull.google.place.type.modal.provider.ts